import styled from 'styled-components';

export const Container = styled.div`
  .btn-hide-search {
    right: -30px;
    top: 20px;
    height: 35px;
    width: 30px;
    background: #03d6a5;
    padding: 2px 5px 0 0;
    text-align: right;
    border-radius: 0 4px 4px 0;

    @media only screen and (max-width: 768px) {
      display: none;
    }

    &:hover {
      background: #fff;
    }
  }

  .hide-bar {
    .btn-hide-search {
      i {
        transform: rotate(0deg);
      }
    }
  }

  .filter {
    &-button {
      @extend .shadow;
    }

    @media (min-width: 992px) {
      &-bar {
        position: fixed;
        top: 3.5em;
        left: 5px;
        height: 100%;
        background: ${(props) => props.theme.$white};
        border-right: 1px solid ${(props) => props.theme.$gray300};
        z-index: 13;
        transition: all 1s;

        &.hasTopBanner {
          top: 136px;
          padding-bottom: 136px;

          .filter-form {
            max-height: calc(100% - 10px);
          }
        }

        &.hide-bar {
          transform: translateX(-100%);
        }
      }

      &-form {
        &::-webkit-scrollbar {
          -webkit-appearance: none;
          width: 7px;

          &-thumb {
            border-radius: 4px;
            background-color: rgba(0, 0, 0, 0.5);
            -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
          }
        }
      }

      &-button {
        position: fixed;
        bottom: 0;
        left: 10px;
      }
    }
  }

  .flash-message-notification {
    padding-left: 25%;

    @media only screen and (max-width: 768px) {
      padding-left: 0;
    }
  }

  .scroll-lateral {
    max-height: calc(100% - 70px);
    overflow-x: hidden;
    overflow-y: visible;
  }

  i {
    color: #000;
  }
`;
